// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1Isjp","title":"AfterBackImages_title__1fio7","images":"AfterBackImages_images__3WiTa"};